export default {
  paid: 'PAID_TICKET',
  free: 'FREE_TICKET',
  pwyw: 'PWYW_TICKET',
};
